import React, { FC, useState } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../design-system/breakpoints';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import PendingRoundedIcon from '@mui/icons-material/PendingRounded';
import Colours from '../../../design-system/colours';

interface ResponsiveActionsProps {
  children: React.ReactNode;
}

const ResponsiveActions: FC<ResponsiveActionsProps> = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const actionElements = React.Children.toArray(children).filter(
    React.isValidElement
  ) as React.ReactElement[];

  return (
    <>
      <DesktopActions>{actionElements}</DesktopActions>

      <MobileActions>
        <IconButton onClick={openMenu}>
          <PendingRoundedIcon
            style={{ color: Colours.OV_BASE, fontSize: '1.75rem' }}
          />
        </IconButton>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
          {actionElements.map((el, idx) => {
            let actionButtonElement: React.ReactElement = el;
            let tooltipTitle: React.ReactNode = null;
            let tooltipProps: any = {};

            if (el.type === Tooltip) {
              tooltipTitle = el.props.title;
              tooltipProps = el.props.componentsProps;

              // unwrap: Tooltip -> span -> actual button
              const spanWrapper = React.Children.only(
                el.props.children
              ) as React.ReactElement;

              actionButtonElement = React.Children.only(
                spanWrapper.props.children
              ) as React.ReactElement;
            }

            const {
              onClick,
              disabled,
              children: label,
            } = actionButtonElement.props;

            const item = (
              <MenuItem
                key={idx}
                disabled={disabled}
                onClick={() => {
                  onClick?.();
                  closeMenu();
                }}
              >
                {label}
              </MenuItem>
            );

            return tooltipTitle ? (
              <Tooltip
                key={idx}
                title={tooltipTitle}
                arrow
                componentsProps={tooltipProps}
              >
                <span>{item}</span>
              </Tooltip>
            ) : (
              item
            );
          })}
        </Menu>
      </MobileActions>
    </>
  );
};

export default ResponsiveActions;

const DesktopActions = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${breakpoints.lg}) {
    display: none;
  }
`;

const MobileActions = styled.div`
  display: none;
  align-items: center;
  @media (max-width: ${breakpoints.lg}) {
    display: flex;
  }
`;
